import React from 'react';
import AppendixPageLayout from '../components/AppendixPageLayout';

const TOC = [
  { id: 'overview', label: 'Overview' },
  { id: 'allowed-chars', label: 'Allowed character classes' },
  { id: 'reference', label: 'Encoding reference' },
];

const ENCODINGS = [
  ['Space', '%20'], ['!', '%21'], ['"', '%22'], ['#', '%23'], ['$', '%24'],
  ['%', '%25'], ['&', '%26'], ['(', '%28'], [')', '%29'], ['*', '%2A'],
  ['+', '%2B'], [',', '%2C'], ['/', '%2F'], [':', '%3A'], [';', '%3B'],
  ['<', '%3C'], ['=', '%3D'], ['>', '%3E'], ['?', '%3F'], ['@', '%40'],
  ['[', '%5B'], ['\\', '%5C'], [']', '%5D'], ['^', '%5E'], ['`', '%60'],
  ['{', '%7B'], ['|', '%7C'], ['}', '%7D'], ['~', '%7E'],
];

const UrlEncoding = () => (
  <AppendixPageLayout
    currentId="url-encoding"
    title="URL Encoding"
    subtitle="Any request data sent to our API that is not properly encoded may result in unexpected errors. Use this table as the authoritative reference when constructing form-encoded bodies."
    toc={TOC}
    mainTestId="appendix-url-encoding-page"
    sidebarTestId="appendix-url-encoding-sidebar"
  >
    <section id="overview" className="bg-white/80 backdrop-blur-sm rounded-lg shadow-md p-8 mb-8 scroll-mt-28">
      <h2 className="text-2xl font-bold text-gray-900 mb-3">Overview</h2>
      <p className="text-gray-700 leading-relaxed">
        The table below contains information about URL-encoded values that will assist when integrating to our services. Any request data sent to our API that is not encoded may result in unexpected errors.
      </p>
    </section>

    <section id="allowed-chars" className="bg-white/80 backdrop-blur-sm rounded-lg shadow-md p-8 mb-8 scroll-mt-28">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Allowed character classes</h2>
      <ul className="list-disc list-inside space-y-2 text-sm text-gray-700 pl-2 leading-relaxed">
        <li><strong>Alpha characters</strong> include <code className="bg-gray-100 px-1.5 py-0.5 rounded text-xs font-mono">A-Z</code>, <code className="bg-gray-100 px-1.5 py-0.5 rounded text-xs font-mono">-</code>, <code className="bg-gray-100 px-1.5 py-0.5 rounded text-xs font-mono">_</code>, <code className="bg-gray-100 px-1.5 py-0.5 rounded text-xs font-mono">.</code>, and <code className="bg-gray-100 px-1.5 py-0.5 rounded text-xs font-mono">a-z</code>.</li>
        <li><strong>Alpha-Numeric characters</strong> include all the Alpha characters above plus the numbers <code className="bg-gray-100 px-1.5 py-0.5 rounded text-xs font-mono">0-9</code>.</li>
        <li>The Alpha character set can also include any of the characters in the reference table below <em>as long as they are URL-encoded</em>.</li>
      </ul>
    </section>

    <section id="reference" className="bg-white/80 backdrop-blur-sm rounded-lg shadow-md p-8 mb-8 scroll-mt-28">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Encoding reference (Windows-1252)</h2>
      <div className="overflow-x-auto">
        <table className="w-full text-left border border-gray-200 rounded-lg overflow-hidden">
          <thead className="bg-gray-100 border-b border-gray-200">
            <tr>
              <th className="p-3 text-xs font-bold text-gray-700 uppercase tracking-wider w-40">Character</th>
              <th className="p-3 text-xs font-bold text-gray-700 uppercase tracking-wider">Windows-1252 encoding</th>
            </tr>
          </thead>
          <tbody>
            {ENCODINGS.map(([ch, enc]) => (
              <tr key={ch + enc} className="border-b border-gray-200 hover:bg-gray-50 transition-colors">
                <td className="p-3 font-mono text-sm font-bold text-gray-900 align-top">{ch}</td>
                <td className="p-3 font-mono text-sm text-emerald-700 align-top">{enc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  </AppendixPageLayout>
);

export default UrlEncoding;
